// Modes de jeu cote client. Chaque mode : id, emoji, nameKey, descKey, source, restricted.
// `source` sert au regroupement visuel dans le lobby (messages / mashups).
// `restricted` : visible/creable seulement par la whitelist (cf. mashupWhitelist.js).
export const GAME_MODES = [
  {
    id: 'classic',
    emoji: '📜',
    nameKey: 'mode_classic_name',
    descKey: 'mode_classic_desc',
    source: 'messages',
  },
  {
    id: 'chrono',
    emoji: '🕰️',
    nameKey: 'mode_chrono_name',
    descKey: 'mode_chrono_desc',
    source: 'messages',
  },
  {
    id: 'discussion',
    emoji: '💬',
    nameKey: 'mode_discussion_name',
    descKey: 'mode_discussion_desc',
    source: 'messages',
  },
  {
    id: 'whoisit',
    emoji: '🕵️',
    nameKey: 'mode_whoisit_name',
    descKey: 'mode_whoisit_desc',
    source: 'messages',
  },
  {
    id: 'mashup',
    emoji: '🎧',
    nameKey: 'mode_mashup_name',
    descKey: 'mode_mashup_desc',
    source: 'mashups',
    restricted: true,
  },
  {
    id: 'blindtest',
    emoji: '🎵',
    nameKey: 'mode_blindtest_name',
    descKey: 'mode_blindtest_desc',
    source: 'mashups',
    restricted: true,
  },
  {
    id: 'coverDraw',
    emoji: '🎨',
    nameKey: 'mode_coverDraw_name',
    descKey: 'mode_coverDraw_desc',
    source: 'mashups',
    restricted: true,
  },
  {
    id: 'studio',
    emoji: '🎤',
    nameKey: 'mode_studio_name',
    descKey: 'mode_studio_desc',
    source: 'mashups',
    restricted: true,
  },
];

// Sources (pour les entetes de regroupement dans le picker).
export const MODE_SOURCES = [
  { id: 'messages', labelKey: 'source_messages', emoji: '💬' },
  { id: 'mashups', labelKey: 'source_mashups', emoji: '🎶' },
  { id: 'creation', labelKey: 'source_creation', emoji: '🎨' },
];
